import { GAMES } from "@/lib/game";

/**
 * Círculo con la inicial del juego en su color. Reemplaza los emojis
 * genéricos (🃏, ⚔️, 🌀, 🔮, 🏴‍☠️) por un avatar minimalista con la
 * primera letra del nombre y el color de marca del juego.
 *
 *   <GameIcon game="pokemon" size="md" />  →  círculo rojo con "P"
 *   <GameIcon game="riftbound" size="sm" /> → círculo azul con "R"
 */
export function GameIcon({ game, size = "md", className = "" }) {
  const meta = GAMES[game] || GAMES.pokemon;
  const letter = (meta.label || game || "?").charAt(0).toUpperCase();
  const sizeCls = size === "xs"
    ? "w-4 h-4 text-[9px]"
    : size === "sm"
      ? "w-5 h-5 text-[10px]"
      : size === "lg"
        ? "w-9 h-9 text-base"
        : size === "xl"
          ? "w-12 h-12 text-xl"
          : "w-6 h-6 text-xs"; // md default
  return (
    <span
      aria-hidden
      data-testid={`game-icon-${game}`}
      className={`inline-flex items-center justify-center rounded-full font-display font-bold shrink-0 ${sizeCls} ${className}`}
      style={{ backgroundColor: `${meta.color}22`, color: meta.color, border: `1px solid ${meta.color}55` }}
    >
      {letter}
    </span>
  );
}

export default GameIcon;
